import React, { useEffect, useState } from "react";
import { requestCanceller } from "../../service/axiosCancelToken";
import { decodeToken } from "../../service/decodeToken";
import { authToken } from "../../service/userService";
import MainContext from "../context/mainContext";
import Cookies from 'universal-cookie';

const GlobalState = props => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const showLogin = () => setShowLoginModal(true);
    const hideLogin = () => setShowLoginModal(false);

    const [loggedIn, setLoggedIn] = useState();
    const login = (user) => setLoggedIn(user);
    const logout = () => setLoggedIn();

    const [shoppingCart, setShoppingCart] = useState([]);

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const authorization = async () => {
            try {
				let token;
				if (localStorage.getItem('token')){

                    token = localStorage.getItem('token');
                    let isExpired = false;
                    let decodedToken = decodeToken(token);
                    let dateNow = Date.now()/1000;
    
                    if(decodedToken.payload.exp < dateNow)
                    {
                        localStorage.removeItem('token');
                        isExpired = true;
                    }
                    if(!isExpired){
                        const { status, data } = await authToken({cancelToken: cancelRequest.signal});
                        if(status === 201){
                            setLoggedIn(data.user);
                            let cookie = new Cookies();
                            if(cookie.get('shoppingCart')){
                                let ids = cookie.get('shoppingCart');
                                setShoppingCart(ids);
                            }
                        }
                    }

                }
                
			} catch (err) {
				if(err.response && err.response.status === 401){
					localStorage.removeItem('token');
				}
            }
            
        }
        authorization();
        return () => {
			cancelRequest.cancel();
        }
    },[])
    return (
        <MainContext.Provider
            value={{
                showLoginModal: showLoginModal,
                showLogin: showLogin,
                hideLogin: hideLogin,
				loggedIn: loggedIn,
                shoppingCart: shoppingCart,
                setShoppingCart: setShoppingCart,
                login: login,
                logout: logout
            }}
        >
            {props.children}
        </MainContext.Provider>
    );
};

export default GlobalState;
